import { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Chip, Link,
} from '@mui/material'
import { WarningAmber } from '@mui/icons-material'
import { warningsCountLabel, warningItems } from './basePlanWarnings'

// FAR-97: a Base Plan's warnings count ("3 warnings"); clicking it opens the
// list. Renders nothing for a Base Plan with no warnings (all built before
// FAR-97). Clicks don't reach the row or menu item it sits in.
export default function BasePlanWarningsLink({ basePlan, title }) {
  const [open, setOpen] = useState(false)
  const label = warningsCountLabel(basePlan)
  if (!label) return null
  const stop = (e) => e.stopPropagation()
  const items = warningItems(basePlan)
  return (
    <>
      <Link component="button" type="button" variant="caption" color="warning.dark" underline="hover"
        data-testid={`bp-warnings-${basePlan.id}`}
        onClick={(e) => { stop(e); setOpen(true) }}
        onMouseDown={stop} onKeyDown={stop}
        // One unit: "⚠ 6 warnings" never breaks across lines; a narrow
        // column wraps the whole link instead.
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, verticalAlign: 'middle', whiteSpace: 'nowrap', flexShrink: 0 }}>
        <WarningAmber sx={{ fontSize: 14 }} aria-hidden /> {label}
      </Link>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth onClick={stop} onKeyDown={stop}
        data-testid="bp-warnings-dialog">
        <DialogTitle sx={{ pb: 1 }}>{title || 'Base Plan warnings'} · {label}</DialogTitle>
        <DialogContent dividers>
          {items.map((w, i) => (
            <Box key={`${w.kind}-${i}`} sx={{ py: 1, '&:not(:last-of-type)': { borderBottom: '1px solid', borderColor: 'divider' } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                <Chip size="small" label={w.label} sx={{ height: 20, fontSize: '0.7rem', bgcolor: '#FEF3C7', color: '#78350F' }} />
                {w.counts && <Typography variant="caption" color="text.secondary">{w.counts}</Typography>}
              </Box>
              <Typography variant="body2">{w.message}</Typography>
              {w.skus.length > 0 && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                  SKUs: {w.skus.join(', ')}{w.moreSkus > 0 ? ` and ${w.moreSkus.toLocaleString()} more` : ''}
                </Typography>
              )}
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
